export const I18N_EVENTS = ['loaded', 'languageChanged'] as const;
